import { BehaviorSubject } from 'rxjs';

export const cookieStateSubject = new BehaviorSubject(false);

const updateCookieState = (value) => {
  cookieStateSubject.next(value);
};

export default updateCookieState;
